import { useState } from 'react'
import {
  Box,
  Card,
  CardContent,
  Chip,
  Collapse,
  Divider,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { getBreakStatus } from '../../../const/productionStatus'
import { formatDateTime, formatNumber } from '../../../utils/format'

const Field = ({ label, value }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2" noWrap title={typeof value === 'string' ? value : undefined}>
      {value}
    </Typography>
  </Box>
)

const BreakCard = ({ info, color }) => {
  const [open, setOpen] = useState(false)

  const status = getBreakStatus(info.status)
  const stages = info.stages || []

  const total = Number(info.quantityInitial) || 0
  const done = Number(info.quantityFinished) || 0
  const percent = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0

  return (
    <Card
      variant="outlined"
      sx={{
        width: 280,
        flexShrink: 0,
        cursor: 'default',
        borderLeft: '4px solid',
        borderLeftColor: color || 'divider',
      }}
    >
      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box
          sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}
        >
          <Typography variant="subtitle2" fontWeight={700} noWrap>
            #{info.numberBreak || '—'}
          </Typography>
          <Chip
            size="small"
            label={info.statusLabel || status.label}
            sx={{ bgcolor: status.color, color: '#fff', fontWeight: 600 }}
          />
        </Box>

        <Stack spacing={1} sx={{ mt: 1.5 }}>
          <Field label="Quantidade" value={formatNumber(info.quantityInitial)} />

          <Box>
            <Typography variant="caption" color="text.secondary" display="block">
              Produzido
            </Typography>
            <LinearProgress
              variant="determinate"
              value={percent}
              sx={{ height: 6, borderRadius: 3, my: 0.5 }}
            />
            <Typography variant="caption" color="text.secondary">
              {done} / {total} ({percent}%)
            </Typography>
          </Box>

          <Field label="Criada em" value={formatDateTime(info.createdAt)} />
          <Field label="Início" value={formatDateTime(info.startedAt)} />
          <Field label="Etapa atual" value={info.currentStage?.name || '—'} />
        </Stack>

        <Divider sx={{ mt: 1.5 }} />

        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}
        >
          <Typography variant="caption" color="text.secondary">
            Etapas ({stages.length})
          </Typography>
          <IconButton size="small" onClick={() => setOpen(value => !value)}>
            {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
        </Box>

        <Collapse in={open} unmountOnExit>
          <Stack spacing={1} sx={{ mt: 1 }}>
            {stages.length === 0 && (
              <Typography variant="caption" color="text.secondary">
                Nenhuma etapa registrada.
              </Typography>
            )}
            {stages.map(stage => (
              <Box key={stage.id} sx={{ p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                <Typography variant="caption" fontWeight={700} display="block">
                  {stage.name || '—'}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                  Início: {formatDateTime(stage.startedAt)}
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block">
                  Término: {formatDateTime(stage.finishedAt)}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Collapse>
      </CardContent>
    </Card>
  )
}

export default BreakCard
